import {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import {
  FolderDocumentContains,
  FolderDocumentUpdate,
} from "./DocumentService";

const CreateFolder = ({ onFolderClose }) => {
  const [loading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const { EditFolderId } = useParams();
  const { FolderId } = useParams();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    GetMasterSystemAlertList();
    if (EditFolderId) {
      getFolderData();
    }
  }, [EditFolderId]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  const addFolderValidation = Yup.object().shape({
    DocName: Yup.string().required("Folder name is mandatory"),
    DocDesc: Yup.string(),
  });

  const addFolderForm = useFormik({
    initialValues: {
      DocName: "",
      DocDesc: "",
    },
    validationSchema: addFolderValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const params = {
        Id: EditFolderId ? EditFolderId : 0,
        LabelId: FolderId ? Number(FolderId) : 0,
        EmpId: userDetails?.EmpId,
        DocPath: "",
        Name: data?.DocName,
        Desc: data?.DocDesc,
        DocTypeId: 101,
        IsOverride: 0,
      };
      try {
        const response = await FolderDocumentUpdate(params);
        if (response?.StatusCode === 2000) {
          setErrorMessage("");
          sessionStorage.setItem("reload", true);
          GetMasterSystemAlertList("Folder_Create", 0);
          addFolderForm.resetForm();
          onFolderClose(true);
        } else {
          setErrorMessage(response?.Message);
        }

        setIsloading(false);
      } catch (error) {
        toster.current.error(ERROR_LIST.PostFolder);
        setIsloading(false);
      }
    },
  });

  async function getFolderData() {
    setIsloading(true);
    const params = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: EditFolderId ? Number(EditFolderId) : 0,
      Search: "",
      Id: 0,
      GUID: "",
      BookMarkedOnly: 0,
    };
    try {
      const responseData = await FolderDocumentContains(params);
      const data = responseData?.Data || [];

      const setEditData = {
        DocName: data[0]?.DocName,
        DocTypeId: data[0]?.DocTypeId,
        Pinned: data[0]?.IsPinned,
        DocDesc: data[0]?.DocDesc,
      };
      addFolderForm.setValues(setEditData);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  return (
    <>
      <div className="">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row">
                <div className="col-md-12 shrink-w">
                  <form onSubmit={addFolderForm.handleSubmit} className="">
                    <div className="">
                      <div className="col-xl-12">
                        <div className="employee-card tile-grid tile-grid-v1">
                          <div id="feed-post-1" className="AnnouncementForm">
                            <div className="third-section">
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <label className="form-label">
                                    Folder Name
                                    <i className="inValidError">*</i>
                                  </label>
                                  <div className="cover-form">
                                    <input
                                      type="text"
                                      name="DocName"
                                      className={
                                        "form-control" +
                                        (addFolderForm.errors.DocName &&
                                        addFolderForm.touched.DocName
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={addFolderForm.handleChange}
                                      value={addFolderForm.values.DocName}
                                      placeholder="Folder Name"
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {addFolderForm.errors.DocName &&
                                    addFolderForm.touched.DocName
                                      ? addFolderForm.errors.DocName
                                      : null}
                                  </div>

                                  <div className="invalid-feedback">
                                    {errorMessage ? errorMessage : null}
                                  </div>
                                </div>
                                
                                <div className="mb-4 col-md-12">
                                  {" "}
                                  <label className="form-label">
                                    Description
                                  </label>
                                  <div className="cover-form">
                                    <textarea
                                      type="text"
                                      cols="1"
                                      rows="4"
                                      name="DocDesc"
                                      maxLength={500}
                                      className="form-control"
                                      onChange={addFolderForm.handleChange}
                                      value={addFolderForm.values.DocDesc}
                                      placeholder="Description"
                                    ></textarea>
                                    <div
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        position: "absolute",
                                        right: "39px",
                                        bottom: "118px",
                                        color:
                                          addFolderForm.values.DocDesc
                                            .length === 500
                                            ? "red"
                                            : "#555",
                                      }}
                                    >
                                      {addFolderForm.values.DocDesc.length}/
                                      {500}
                                    </div>
                                  </div>
                                  
                                </div>{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="btns-grp">
                          <button
                            type="button"
                            className="cancelbtn-click"
                            data-bs-dismiss="modal"
                            onClick={()=> addFolderForm.resetForm()}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="savebtn-click btn-purple rounded"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default CreateFolder;
